import parseDialogue from "../../util/parseDialogue";

export const DisarrayL8 = parseDialogue(`
disarray:l8:100-300

#100 Terrific. Thanks for handling that security. I could've done it myself, but that saved me some time.
>200 No problem.

#200 Well, once the program is put together, everything will be set for S.M.A.R.T. See you soon.
>300 Close.
`);
